<template>
  <ul-page class="page-virtual-homePage">
    <template v-slot:left>
      <div class="page-header-left" @click="back">
        <i class="iconfont icon-shangyige"></i>返回上一级
      </div>
      <span class="page-header-name">{{ virtual.name }}</span>
    </template>
    <template v-slot:right >
      <ul-button class="page-header-right" size="small" v-if="virtual.publishState == 0" hollow @click="publishCourses">发布课程</ul-button>
      <div v-else></div>
    </template>
    <div class="page-content">
      <div class="menu">
        <img class="home-page-img" :src="virtual.cover || homePage">
        <div class="menu-list">
          <div class="menu-item" v-for="item in courseMenuList" :key="item.component" :class="{'activate': activateRouter == item.component}" @click="changMenu(item.component)">
            <i :class="`iconfont ${item.icon}`"></i><span>{{ item.typaName }}</span>
          </div>
          <div class="line"></div>
          <div class="menu-item" v-for="item in settingMenuList" :key="item.component" :class="{'activate': activateRouter == item.component}" @click="changMenu(item.component)">
            <i :class="`iconfont ${item.icon}`"></i><span>{{ item.typaName }}</span>
          </div>
        </div>
      </div>
      <div class="content-right">
        <component :is="currentComponent"></component>
      </div>
    </div>
  </ul-page>
</template>

<script>
import experimentalRes from '../experimentView/resource/experimentalRes.vue'
import courseResource from '../experimentView/resource/courseResource.vue'
import basicInfo from '../experimentView/basicInfo.vue'
import teamMembers from '../experimentView/teamMembers.vue'
import homePage from '@/assets/images/virtual/homePage.png'
import { publishVirtualCourse, getCourseInfo } from '@/api/courseApi/virtual.js'
import { mapGetters, mapActions } from "vuex";
export default {
  name: 'page-virtual-homePage',
  components: {
    experimentalRes,
    courseResource,
    basicInfo,
    teamMembers
  },
  computed: {
    ...mapGetters("virtual", { virtual: "virtual" }),
    courseId () {
      return this.$route.params.id
    },
    isAiCourse () {
      // 原页面逻辑中非虚仿课程都按 AI 通识课展示。
      return this.virtual.type != 1
    },
    courseMenuList () {
      let list = [
        {
          typaName: this.isAiCourse ? '实训项目' : '实验资源',
          component: 'experimentalRes',
          icon: 'icon-experimental_resources'
        }
      ]
      if (this.isAiCourse) {
        list.push({
          typaName: '实验资源',
          component: 'courseResource',
          icon: 'icon-a-folder-open-fill1'
        })
      }
      return list
    },
    settingMenuList () {
      return this.meunList.filter(item => item.component === 'basicInfo' || item.component === 'teamMembers')
    },
    currentComponent () {
      return this.meunMap[this.activateRouter] ? this.meunMap[this.activateRouter].component : 'experimentalRes'
    },
  },
  data() {
    return {
      homePage,
      activateRouter: this.$route.params.router,
      meunList : [
        {typaName: '实验资源', component: 'experimentalRes', icon: 'icon-experimental_resources'},
        {typaName: '实验资源', component: 'courseResource', icon: 'icon-a-folder-open-fill1'},
        {typaName: '基本信息', component: 'basicInfo', icon: 'icon-basic_information'},
        {typaName: '团队成员', component: 'teamMembers', icon: 'icon-mulu-chengyuan'},
      ],
      meunMap: {
        'experimentalRes': {
          typaName: '实验资源',
          component: 'experimentalRes'
        },
        'courseResource': {
          typaName: '实验资源',
          component: 'courseResource'
        },
        'basicInfo': {
          typaName: '基本信息',
          component: 'basicInfo'
        },
        'teamMembers': {
          typaName: '团队成员',
          component: 'teamMembers'
        },
      }
    }
  },
  created() {
    getCourseInfo({courseId: this.courseId})
    .then(({result})=>{
      this.setVirtual(result)
    })
  },
  methods: {
    ...mapActions("virtual", ["setVirtual"]),
    changMenu(router) {
      this.$router.replace({ name: 'virtualHomePage', params: { id: this.$route.params.id ,router: router }})
      this.activateRouter = router
    },
    publishCourses() {
      this.$confirm('发布课程后，教师可以在班课中引用实验资源，确定发布吗？','发布课程')
      .then(()=>{
        publishVirtualCourse(this.courseId)
        .then(()=>{
          this.virtual.publishState = 1
          this.setVirtual(this.virtual)
          this.$message({
            message: '发布成功',
            type: 'success'
          })
        })
      })
    },
    back() {
      this.$router.back()
    }
  }
}
</script>

<style lang="scss" scoped>
/* 与 .page-content .menu 宽度一致 */
$virtualHomeMenuWidth: 227px;

.page-header-left {
  cursor: pointer;
  display: flex;
  align-items: center;
  i {
    color: #cbcbd1;
    font-weight: bold;
    margin-right: 6px;
  }
}
.page-header-name {
  margin-left: 155px;
  font-size: 18px;
  font-weight: 600;
}
.page-content {
  display: flex;
  min-height: calc(100vh - 50px);
  .menu {
    width: $virtualHomeMenuWidth;
    border-right: 1px solid #E3E3E9;
    .home-page-img {
      width: $virtualHomeMenuWidth;
      display: block;
      margin-bottom: 20px;
    }
    .menu-list {
      .line {
        width: 180px;
        height: 1px;
        background: #E3E3E9;
        margin: 8px auto;
      }
      .menu-item {
        cursor: pointer;
        padding: 0 28px;
        font-size: 18px;
        display: flex;
        align-items: center;
        height: 48px;
        color: #444;
        &.activate {
          color: #EA5947;
          border-left: 4px solid #EA5947;
          padding-left: 24px;
          i {
            color: #EA5947;
          }
        }
        &:hover {
          background: rgba(239, 239, 247, 0.70);
        }
        i {
          margin-right: 18px;
          font-size: 22px;
          color: #CBCBD1;
        }
      }
    }
  }
  .content-right {
    padding: 0 32px 106px;
    width: 100%;
  }
}
</style>
